/**
 * Advertiser-scoped reusable US ZCTA / Census area lists (zipText) for CareMap carousel targeting.
 * Path: users/{uid}/mapCarouselZipCollections/{collectionId}
 */
export const MAP_CAROUSEL_ZIP_COLLECTIONS_SUBCOLLECTION = "mapCarouselZipCollections";
